// Click-and-drag horizontal scrolling for the product card color swatch row (mouse only).
(function () {
  const SCROLLER = '.product__color-swatches--scroller';
  const SCROLLABLE_CLASS = 'is-scrollable';
  const DRAGGING_CLASS = 'is-dragging';
  // pixels the pointer must travel before a press turns into a drag
  const DRAG_THRESHOLD = 5;

  let drag = null;

  function isOverflowing(el) {
    return el.scrollWidth - el.clientWidth > 1;
  }

  // flag the row on hover so the grab cursor only shows when there is somewhere to scroll
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

    const scroller = event.target.closest(SCROLLER);
    if (!scroller) return;

    scroller.classList.toggle(SCROLLABLE_CLASS, isOverflowing(scroller));
  });

  document.addEventListener('pointerdown', function (event) {
    // primary button only, and never on touch or pen where native scrolling already works
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    if (!(event.target instanceof Element)) return;

    const scroller = event.target.closest(SCROLLER);
    if (!scroller || !isOverflowing(scroller)) return;

    drag = {
      scroller: scroller,
      startX: event.clientX,
      startScroll: scroller.scrollLeft,
      moved: false,
    };
  });

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!drag) return;

      const delta = event.clientX - drag.startX;
      if (!drag.moved) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        drag.moved = true;
        drag.scroller.classList.add(DRAGGING_CLASS);
      }

      // stop the browser selecting label text or starting a native image drag
      event.preventDefault();
      drag.scroller.scrollLeft = drag.startScroll - delta;
    },
    { passive: false },
  );

  function suppressClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function endDrag() {
    const active = drag;
    drag = null;
    if (!active) return;

    active.scroller.classList.remove(DRAGGING_CLASS);
    if (!active.moved) return;

    // swallow the click that follows the drag so the swatch does not change the variant
    document.addEventListener('click', suppressClick, { capture: true, once: true });
    setTimeout(function () {
      document.removeEventListener('click', suppressClick, { capture: true });
    }, 0);
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('dragstart', function (event) {
    if (drag && drag.moved) event.preventDefault();
  });
})();
